import { render, staticRenderFns } from "./jsonView.vue?vue&type=template&id=eb497986&scoped=true"
import script from "./jsonView.vue?vue&type=script&lang=js"
export * from "./jsonView.vue?vue&type=script&lang=js"
import style0 from "./jsonView.vue?vue&type=style&index=0&id=eb497986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb497986",
  null
  
)

export default component.exports